export const STREAMER_TITLE = process.env.REACT_APP_STREAMER_TITLE || "Web Guest";
export const DUPLEX_TITLE = process.env.REACT_APP_DUPLEX_TITLE || "Web Guest 2";
export const PREVIEW_TITLE = process.env.REACT_APP_PREVIEW_TITLE || "Web Preview";
